import PrimoPianoContainer from './PrimoPianoContainer';

export default PrimoPianoContainer;
